import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Secretary } from 'src/models/secretary';
import { Organization } from 'src/models/organization';
import { BehaviorSubject, Observable } from 'rxjs';
import { Account } from 'src/models/account.model';

@Injectable({
  providedIn: 'root',
})
export class OrganizationsService {
  public selectedOrg = new BehaviorSubject<Organization | undefined>(undefined);

  constructor(private api: ApiService) {}

  async saveOrganization(org: Organization) {
    return this.api.post<Organization>(`${this.api.endpoints.organizations}/SaveOrganization`, org);
  }
  async getOrganization(id: number) {
    return await this.api.get<Organization>(
      `${this.api.endpoints.organizations}/Get?organizationId=${id}`,
    );
  }

  async getOrganizationsForUser() {
    //I think we can cache this in localstorage. org permissions shouldn't change often and we can make someone log out if needed
    return await this.api.get<Organization[]>(
      `${this.api.endpoints.organizations}/GetUserOrganizations`,
    );
  }

  async saveSecretary(secretary: Secretary) {
    return await this.api.post(
      `${this.api.endpoints.organizations}/secretary`,
      secretary,
    );
  }

  async setOrganizationDefaultSecretary(orgId: number, secretaryId: number) {
    return await this.api.post(
      `${this.api.endpoints.organizations}/SetSecretaryDefault?orgId=${orgId}&secretaryId=${secretaryId}`,
      null,
    );
  }

  async getAllStaffAccounts(organizationId: number) : Promise<Account[]> {
    return this.api
      .get<Account[]>(this.api.endpoints.organizations + '/getAllStaffMembers?organizationId=' + organizationId)
  }
}
